import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InterceptorHttpParams } from '../../../core/error/http-error-interceptor.service';
import { UserTrackerService } from '../../../user-tracker/user-tracker.service';

const resourceBaseUrl = '/api/v1/eloqua';

export interface IEloquaSalesLead {
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  Comments?: string;
  ImInquiringAbout?: string;
  Reason?: string;
  Industry?: string;
  Job_Title1?: string;
  BusPhone?: string;
  C_Country?: string;
  C_State_Prov?: string;
  company?: string;
  ImInterestedIn?: string;
  formId?: number;
  data?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
}

export interface IEloquaProductSalesLead extends IEloquaSalesLead {
  EmailAddress?: string;
  AssetDetail?: string;
}

export interface IFieldValues {
  type: string;
  id: string;
  name: string;
  value: string;
}

export interface IEloquaSubmitResponse {
  type: string;
  id: string;
  fieldValues: IFieldValues[];
}

export interface ILeadProduct {
  id?: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class EloquaSalesLeadDataAccessService {
  constructor(
    private _httpClient: HttpClient,
    private _userTrackerService: UserTrackerService,
  ) {}

  public createSalesLead(
    eloquaData: IEloquaSalesLead,
    eloquaFormID: number,
    data: string,
  ): Observable<IEloquaSubmitResponse> {
    const utmCodes = this._userTrackerService.getTrackingInformation();
    if (utmCodes) {
      if (utmCodes.utm_campaign) {
        eloquaData.utm_campaign = utmCodes.utm_campaign;
      }
      if (utmCodes.utm_content) {
        eloquaData.utm_content = utmCodes.utm_content;
      }
      if (utmCodes.utm_medium) {
        eloquaData.utm_medium = utmCodes.utm_medium;
      }
      if (utmCodes.utm_source) {
        eloquaData.utm_source = utmCodes.utm_source;
      }
    }
    eloquaData.formId = eloquaFormID;
    eloquaData.data = data;
    // Example: disable global error handling for all http errors.
    // Don't handle any errors globally. We don't want the download interrupted.  We will log the error instead.
    const params = new InterceptorHttpParams({
      statusCodesToIgnore: (_error) => true,
    });
    return this._httpClient.post<IEloquaSubmitResponse>(resourceBaseUrl, eloquaData, { params });
  }
}
